import HTTP from '../HTTP';
import gestionErreur from '@/services/general/gestionErreur';

const RECOM_URL = 'PortailAnnonceur/';
const OPPORTUNITE_URL = 'opportunites/';
const CLIENTS_URL = 'clients';

export async function getDetailRecom(id) {
  return await HTTP.get(RECOM_URL, { params: { hash: id } });
}

export async function exportPdf(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(RECOM_URL + 'actionRecom/pdf', { responseType: 'blob', params: { hash: id } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function exportRecapPdf(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(RECOM_URL + 'actionRecom/recap-pdf', { responseType: 'blob', params: { hash: id } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function exportExcel(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(RECOM_URL + 'actionRecom/exportExcelRecom', { responseType: 'blob', params: { hash: id } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getRecomGroupe(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(RECOM_URL + 'by/groupe/' + id);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getRecomClient(hash) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(RECOM_URL + 'recoms/client/havas', { params: { hash } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function urlToDataUrl(url) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(`${OPPORTUNITE_URL}urlToDataUrl`, { params: { url } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function urlToDataUrlPortail(url, hash) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(`${RECOM_URL}urlToDataUrl`, { params: { url, hash } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getEnseignes(idClients) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.post(`${CLIENTS_URL}/manyCliNum`, { idClients });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function browseDetailClient(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(CLIENTS_URL + '/' + id);
    return response;
  } catch (e) {
    throw e;
  }
}


export async function GetPiecesJointesAsync(elementId) {
  const response = await HTTP.get(CLIENTS_URL + '/piecesJointes/' + elementId);
  return response;
}

export async function browseClients(query) {
  try {
    const response = await HTTP.get(CLIENTS_URL, {
      params: {
        ...query,
        whithLogo: '',
      }
    });
    return response;
  } catch (e) {
    gestionErreur('Erreur lors de la récupération des concurrents', e);
  }
}